import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=25b9b1f8&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=25b9b1f8&prod&scoped=true&lang=less"
import style1 from "./FormPage.vue?vue&type=style&index=1&id=25b9b1f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b9b1f8",
  null
  
)

export default component.exports